<template>
  <button
    :class="{
      'disabled': disabled
    }"
    @click="clicked"
  >
    <p4a-icon
      class="svg-image"
      :class="{
        'disabled': disabled
      }"
      :style="{
        'transform': 'rotate(' + rotation + 'turn)'
      }"
      :color="color"
      :icon="icon"
    />
  </button>
</template>

<script>
  export default {
    name: 'IconButton',
    data () {
      return {
      }
    },
    components: {
    },
    props: {
      color: {
        default: '#000000',
        type: String
      },
      icon: {
        default: '404',
        type: String
      },
      disabled: {
        default: false,
        type: Boolean
      },
      rotation: {
        default: 0.0,
        type: Number
      }
    },
    methods: {
      clicked () {
        let self = this
        if (!self.disabled) {
          self.$emit('clicked')
        }
      }
    },
    computed: {
    },
    watch: {
    }
  }
</script>

<style lang="scss" scoped>
  /*@import "~ui.kit.styling";*/
  @import '../uikit';

  button {
    width: 38px;
    height: 38px;
    cursor: pointer;
    margin: 0;
    padding: 9px;
    border-radius: 2px;
    color: $mediumGreyFont;
    background-color: transparent;
    border: 1px solid transparent;
    &:hover {
      color: $darkGreyFont;
    }
    .svg-image {
      width: 13px;
      height: 13px;
    }
  }

</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/sns-components/kit-components/buttontemplates/IconButton.vue